module.exports = __webpack_public_path__ + "media/images/responsive/page_common/scroll_arrow-851dd46c7967b1e83cd86e6772424585.svg";